<ng-container *ngIf="blog">
    <div class="content--top">
        <div class="content--top__title">
            <div class="content-container">
                <h1>{{blog.title}}</h1>
            </div>
        </div>
        <div class="content--top__lead">
            <div class="content-container">
                <div class="content--top__lead__container">
                    <div class="content--top__lead__image">
                        <div class="image-container">
                            <img src="{{blog.main_picture.largeUrl}}" alt="{{blog.main_picture.alternativeText}}">
                        </div>
                    </div>
                    <div class="content--top__lead__title">
                        <h2>{{blog.subtitle}}</h2>
                        <div class="content--top__lead__title__separator"></div>
                    </div>
                    <div class="content--top__lead__description" [innerHTML]="richtextService.trustHTML(changeListStyle(blog.lead))"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="content--main">
        <div class="content-container">
            <ng-container *ngFor="let content of blog.blog_text">
                <div class="content__accordions" *ngIf="content.__component === 'blog.accordion'">
                    <app-offer-accordion *ngFor="let item of content.fields" [accordion]="item"></app-offer-accordion>
                </div>

                <a *ngIf="content.__component === 'blog.link'" class="navigation-button" routerLink="{{content.link}}">
                    <span i18n class="navigation-button__label">weiterlesen</span>
                    <div class="navigation-button__arrow">
                        <img src="assets/icons/navigation-arrow.svg">
                    </div>
                </a>

                <div *ngIf="content.__component === 'blog.root-text'" [innerHTML]="richtextService.trustHTML(changeListStyle(content.text))"></div>
            </ng-container>
        </div>
        <div class="content-container wide">
            <app-contact-form></app-contact-form>
        </div>
    </div>

    <div class="content--bottom">
        <img src="{{blog.mood_picture.largeUrl}}" alt="{{blog.mood_picture.alternativeText}}">
    </div>
</ng-container>
